import usePageTitle from 'lib/hooks/usePageTitle';

import { withErrorBoundary } from 'components/shared/Error/Boundary';
import OrdersTable from 'components/shared/Forms/Custom/Orders/Orders';

const Orders = ({ fromPatient = false }) => {
  usePageTitle('Orders');

  return <OrdersTable showHeader showFooter pagination fromPatient={fromPatient} />;
};

export default withErrorBoundary(Orders);
